<div
  class="lex-xi-tree-picker__container"
  *transloco="let t; prefix: 'lex-xi-tree-picker-component'"
>
  <div class="lex-xi-tree-picker__search-container">
    <div class="lex-xi-tree-picker__search-icon">
      <xi-icon-button
        [class.lex-xi-tree-picker--hidden]="!searchValue()"
        icon="cancel_circle"
        (onClick)="applyFilter('')"
      ></xi-icon-button>
      <xi-icon-button
        [class.lex-xi-tree-picker--hidden]="searchValue()"
        icon="search"
      ></xi-icon-button>
    </div>

    <input
      #searchInput
      [value]="searchValue()"
      (input)="applyFilter($event.target.value)"
      class="lex-xi-tree-picker__search-input"
    />
  </div>

  <div class="lex-xi-tree-picker__content">
    @if (!datasource?.length) {
      <div class="lex-xi-tree-picker__no_results">
        <p>{{ t('no-results') }}</p>
      </div>
    }
    <mat-tree #tree [dataSource]="datasource" [levelAccessor]="levelAccessor">
      <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodePadding
        [style.display]="node.visible ? 'flex' : 'none'"
        (click)="selectNode(node)"
        [class.lex-xi-tree-picker--selected]="node.id === selectedNode()?.id"
      >
        {{ node.title }}
        <div [hidden]="node.id !== selectedNode()?.id" class="lex-xi-tree-picker--selected-icon">
          <xi-icon icon="circle_check_filled" color="CX"></xi-icon>
        </div>
      </mat-tree-node>

      <mat-tree-node
        *matTreeNodeDef="let node; when: isExpandable"
        matTreeNodePadding
        matTreeNodeToggle
        [isExpandable]="node.isExpandable"
        [isExpanded]="node.isExpanded"
        [cdkTreeNodeTypeaheadLabel]="node.title"
        (expandedChange)="onExpandedChange(node, $event)"
        class="lex-xi-tree-picker--striped"
      >
        <mat-icon class="lex-xi-tree-picker__expansion-icon">
          {{ tree.isExpanded(node) ? 'indeterminate_check_box' : 'add_box' }}
        </mat-icon>
        {{ node.title }}
      </mat-tree-node>
    </mat-tree>
  </div>
</div>
